/* eslint-disable @typescript-eslint/no-explicit-any */
import {useCurrentTabTitle} from '../../hooks/useCurrentTabTitle';

export const PrivateRoute = ({children}: any) => {
  document.title = useCurrentTabTitle();

  return children;
};
